import { get, post } from '@/api/core'

export namespace memberRequest {
  /** 申请人员详情 */
  export function info(c: string) {
    return get<{
      avatar: null | string
      email: string
      hasProcessed: boolean
      name: string
      hasSeat: boolean
      isAgree: boolean
    }>('/temp_staff/get_apply_info', { c })
  }

  /** 处理申请 */
  export function deal(p: { c: string; isAgree: boolean }) {
    return post('/temp_staff/apply_deal', {}, p)
  }
}
